import { MessageSquarePlus } from "lucide-react";
import { Button } from "@/components/ui/button";

const FEEDBACK_URL =
  "https://github.com/michelbr84/fluxswap-dex/issues/new?labels=feedback&template=feedback.yml&title=%5BFeedback%5D+";

/**
 * Floating feedback button — fixed to bottom-right corner.
 * Opens a GitHub issue with the "feedback" label pre-applied.
 */
export function FeedbackButton() {
  return (
    <a
      href={FEEDBACK_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50"
    >
      <Button
        variant="outline"
        size="icon"
        className="h-11 w-11 rounded-full shadow-lg border-border/50 bg-background/80 backdrop-blur-sm hover:bg-secondary"
        aria-label="Send feedback"
      >
        <MessageSquarePlus className="h-5 w-5" />
      </Button>
    </a>
  );
}
